import { ConditionalFunctionString } from '../../conditions.types'

// Substring matching for free-form text fields.
export const textIncludes: ConditionalFunctionString = ({ property, value }) =>
  `${property}.includes(${JSON.stringify(value)})`

export const textExcludes: ConditionalFunctionString = ({ property, value }) =>
  `!${property}.includes(${JSON.stringify(value)})`

// Null-safe emptiness checks. The `(prop || "")` coalescing collapses
// undefined / null to the empty string so the comparison doesn't crash on a
// missing value.
export const textIsEmpty: ConditionalFunctionString = ({ property }) =>
  `(${property} || "") === ""`

export const textIsNotEmpty: ConditionalFunctionString = ({ property }) =>
  `(${property} || "") !== ""`
